import React from "react";
import { Message, Card, Icon, Tab } from "semantic-ui-react";
import "react-vis/dist/style.css";
import "../css/home.css";
import Utils from "../util/Utils";

const indices = [
  { label: "DOW", name: "Dow Jones Industrial Average" },
  { label: "SP500", name: "S&P 500" },
  { label: "NASDAQ", name: "NASDAQ Composite" },
  { label: "Russell", name: "Russell 2000" },
  { label: "VIX", name: "CBOE Volatility Index" },
];

const Macro_Movers = [
  { label: "Bitcoin", symbol: "BTCUSD", source: "bitcoin" },
  { label: "Gold", symbol: "GCUSD", source: "gold" },
  { label: "Silver", symbol: "SIUSD", source: "silver" },
  { label: "Oil", symbol: "CLUSD", source: "oil" },
];

const screenerMap = {
  DOW: "dowjones_constituent",
  SP500: "sp500_constituent",
  NASDAQ: "nasdaq_constituent",
  Russell: "Russell Small Cap 2000 Stocks",
};

const getColor = (change) => (change < 0 ? "rgb(206, 44, 42)" : "green");
const getIcon = (change) => (change < 0 ? "triangle down" : "triangle up");

const Markets = ({
  indexList,
  bitcoin,
  gold,
  silver,
  oil,
  onClickIndexFunction,
}) => {
  const sources = {
    bitcoin: bitcoin || [],
    gold: gold || [],
    silver: silver || [],
    oil: oil || [],
  };
  const getCard = (item, name, clickable = false) => {
    if (!item) return null;

    const bgColor = getColor(item.change);
    const icon = getIcon(item.change);
    const header = name || item.name?.split(" ")[0];

    return (
      <div className="market-card" key={name}>
        <Card
          raised
          onClick={
            clickable && name !== "VIX"
              ? () => onClickIndexFunction(screenerMap[name])
              : null
          }
          style={{
            cursor: clickable && name !== "VIX" ? "pointer" : "default",
            width: "100%",
          }}
        >
          <Card.Content
            style={{
              backgroundColor: bgColor,
              textAlign: "center",
              padding: "0.35em 0.5em",
            }}
          >
            <Card.Header
              style={{
                color: "white",
                fontSize: "0.95em",
                margin: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {header} <Icon name={icon} /> (
              {Utils.format_number(item.changesPercentage)}%)
            </Card.Header>
            <Card.Description
              style={{
                color: "white",
                marginTop: "0.2em",
                fontSize: "0.9em",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {Utils.format_nodecimal(item.price)} (
              {Utils.format_number(item.change)})
            </Card.Description>
          </Card.Content>
        </Card>
      </div>
    );
  };

  const renderCards = (data, isIndex = false) => {
    return (
      <>
        <div className="market-card-row">
          {data.map((item) =>
            isIndex
              ? getCard(
                  indexList?.find((obj) => obj.name === item.name),
                  item.label,
                  true
                )
              : getCard(
                  // replace eval() with a safe sources map
                  (sources[item.source] || []).find((obj) => obj.symbol === item.symbol),
                  item.label
                )
          )}
        </div>
        {isIndex ? (
          <div
            style={{
              textAlign: "center",
            }}
          >
            <Message info compact size="small" className="custom-message">
              <Icon name="info circle"></Icon>
              Click on the index above to see the stocks included in that Index
            </Message>
          </div>
        ) : null}
      </>
    );
  };

  const panes = [
    {
      menuItem: "Indices",
      render: () => (
        <Tab.Pane className="borderless-pane" attached={false}>
          {renderCards(indices, true)}
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Macro Movers",
      render: () => (
        <Tab.Pane className="borderless-pane">
          {renderCards(Macro_Movers)}
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="markets-tab-wrapper">
      <Tab
        menu={{
          color: "blue",
          secondary: true,
          pointing: true,
        }}
        panes={panes}
      />
    </div>
  );
};

export default Markets;
